// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bf0bd5a1","644":"3b4bbbff","977":"fa803470"}[chunkId] + ".chunk.js";
};